import React, { useState } from 'react';
import { signup } from '../api';
import { Box, Typography, TextField, Button, Link } from '@mui/material';
import { Link as RouterLink} from 'react-router-dom';

const SignupPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(formData);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 3,
        maxWidth: 400,
        margin: '0 auto',
        boxShadow: 3,
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Créer un compte
      </Typography>

      {success ? (
        <Typography variant="body1" color="primary">
          Compte créé avec succès !{' '}
          <Link component={RouterLink} to="/login" style={{ textDecoration: 'none' }}>
            Connectez-vous ici
          </Link>.
        </Typography>
      ) : (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {error && (
            <Typography variant="body2" sx={{ color: 'error.main', marginBottom: 2 }}>
              {error}
            </Typography>
          )}
          
          <TextField
            label="Nom"
            name="name"
            type="text"
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
          
          <TextField
            label="Email"
            name="email"
            type="email"
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
          
          <TextField
            label="Mot de passe"
            name="password"
            type="password"
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
            variant="outlined"
          />
          
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            S'inscrire
          </Button>
        </form>
      )}

      <Typography variant="body2" sx={{ mt: 2 }}>
        Déjà un compte ?{' '}
        <Link component={RouterLink} to="/login" style={{ textDecoration: 'none' }}>
          Connectez-vous ici
        </Link>.
      </Typography>
    </Box>
  );
};

export default SignupPage;